import React from "react";

// Logos oficiais (horizontais, fundo transparente). Cada um tem versão clara para o modo escuro.
const LOGOS = {
  iep: {
    light: "/brand/logo-horizontal.webp",
    dark: "/brand/logo-horizontal-dark.webp",
    alt: "IEP – In'Nova Educação Profissional",
  },
  membros: {
    light: "/brand/logo-area-membros.webp",
    dark: "/brand/logo-area-membros-dark.webp",
    alt: "Cabeleireiro Científico Formulador - Área de Membros",
  },
};

export const Brand = ({ light = false, size = "md", variant = "iep", className = "" }) => {
  const logo = LOGOS[variant] || LOGOS.iep;
  const h = size === "lg" ? "h-14" : size === "sm" ? "h-7" : "h-9 sm:h-10";
  const img = light ? (
    <img src={logo.light} alt={logo.alt} className={`${h} w-auto object-contain`} />
  ) : (
    <>
      <img src={logo.light} alt={logo.alt} className={`${h} w-auto object-contain dark:hidden`} />
      <img src={logo.dark} alt="" aria-hidden="true" className={`${h} w-auto object-contain hidden dark:block`} />
    </>
  );
  if (light) {
    return (
      <div data-testid="brand-logo" className={`inline-flex items-center rounded-xl bg-white px-4 py-3 shadow-md ${className}`}>
        {img}
      </div>
    );
  }
  return (
    <div data-testid="brand-logo" className={`inline-flex items-center ${className}`}>
      {img}
    </div>
  );
};
